import { render, staticRenderFns } from "./MonthlyDollarInput.vue?vue&type=template&id=3860a9f4&scoped=true&"
import script from "./MonthlyDollarInput.vue?vue&type=script&lang=js&"
export * from "./MonthlyDollarInput.vue?vue&type=script&lang=js&"
import style0 from "./MonthlyDollarInput.vue?vue&type=style&index=0&id=3860a9f4&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3860a9f4",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCol } from 'vuetify/lib/components/VGrid';
import { VRow } from 'vuetify/lib/components/VGrid';
installComponents(component, {VCol,VRow})
